import React from "react";

/** Keep in sync with api/utils/kycFailReasons.js */
export const KYC_FAIL_REASON_OPTIONS = [
  { code: "photo_blurry", label: "Aadhaar photo is blurry or unreadable" },
  { code: "photo_cropped", label: "Full Aadhaar card not visible in photo" },
  { code: "wrong_document", label: "Uploaded document is not Aadhaar card" },
  { code: "front_back_mismatch", label: "Front and back images do not match" },
  { code: "name_mismatch", label: "Name on Aadhaar does not match profile name" },
  { code: "dob_mismatch", label: "Date of birth does not match Aadhaar" },
  { code: "aadhaar_invalid", label: "Aadhaar number is invalid or incorrect" },
  { code: "duplicate_aadhaar", label: "Aadhaar is already linked to another account" },
  { code: "edited_photo", label: "Photo appears edited or tampered" },
  { code: "expired_or_invalid_card", label: "Aadhaar card image is not valid" },
  { code: "selfie_required", label: "Clear Aadhaar photos required (not a screen photo)" },
  { code: "other", label: "Other (type note below)" },
];

export default function KycRejectReasonFields({
  failReasonCode,
  onFailReasonCodeChange,
  failReasonNote,
  onFailReasonNoteChange,
}) {
  return (
    <div className="mt-2">
      <label className="form-label fw-semibold text-danger mb-1">
        Reject reason <span className="text-danger">*</span>
      </label>
      <select
        className="form-select form-select-sm"
        value={failReasonCode}
        onChange={(e) => onFailReasonCodeChange(e.target.value)}
        required
      >
        <option value="">— Select reason (shown to user on KYC page) —</option>
        {KYC_FAIL_REASON_OPTIONS.map((r) => (
          <option key={r.code} value={r.code}>
            {r.label}
          </option>
        ))}
      </select>
      {failReasonCode === "other" && (
        <textarea
          className="form-control form-control-sm mt-2"
          rows={2}
          placeholder="Enter reason (user will see this on KYC page)"
          value={failReasonNote}
          onChange={(e) => onFailReasonNoteChange(e.target.value)}
          maxLength={500}
        />
      )}
      <p className="small text-muted mb-0 mt-2">
        User will see this reason first, then can submit KYC again.
      </p>
    </div>
  );
}
